import { jsx as n } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { B as f } from "./Banner-BBfZio8n.js";
import { B as p } from "./Button-icgr8OM9.js";
const d = s(
  function({ goal: r, title: a, body: e, loadDemoLabel: o, onLoadDemo: t, onDismiss: m, dismissAriaLabel: i, ...c }, l) {
    return /* @__PURE__ */ n(
      f,
      {
        ref: l,
        tone: "accent",
        variant: "gradient",
        title: a,
        action: /* @__PURE__ */ n(p, { variant: "primary", size: "sm", onClick: t, children: o }),
        onDismiss: m,
        dismissAriaLabel: i,
        "data-ls-component": "ftu-welcome-banner",
        "data-goal": r,
        ...c,
        children: e
      }
    );
  }
);
d.displayName = "FtuWelcomeBanner";
export {
  d as F
};
//# sourceMappingURL=FtuWelcomeBanner-TlfAd6zl.js.map
